import { render, staticRenderFns } from "./GenerateAudioTTS.vue?vue&type=template&id=3bfd02a0&scoped=true&"
import script from "./GenerateAudioTTS.vue?vue&type=script&lang=js&"
export * from "./GenerateAudioTTS.vue?vue&type=script&lang=js&"
import style0 from "./GenerateAudioTTS.vue?vue&type=style&index=0&id=3bfd02a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfd02a0",
  null
  
)

export default component.exports